<template>
	<div class="wrapper authentication-page">
		<!-- Header -->
		<Header />
		<!-- HeaderMenu -->
		<HeaderMenu />

		<div class="contents">
			<div class="layout">
				<div class="left">
					<div class="pc-only">
						<Sidebar />
					</div>
				</div>
				<div class="right">
					<h1>{{ $t("Two-factor authentication") }}</h1>
					<div class="page-contents">
						<div class="page-ttl">
							<h2>{{ $t("Two-factor authentication") }}</h2>
						</div>
						<h3>{{ $t("Download Google Authenticator APP") }}</h3>
						<p class="txt">
							{{
								$t(
									"iOS users may go to App Store and search for “Google Authenticator” to download the app."
								)
							}}<br />
							{{
								$t(
									"Android users may access your respective app store and search for “Google Authenticator” to download the app."
								)
							}}
						</p>
						<ul class="list">
							<li>
								<router-link to="#" class="link-over">
									<div class="img">
										<img
											src="../assets/img/google-img1.svg"
											alt="App Store"
										/>
									</div>
									<p class="name">App Store</p>
								</router-link>
							</li>
							<li>
								<router-link to="#" class="link-over">
									<div class="img">
										<img
											src="../assets/img/google-img2.svg"
											alt="Google Play"
										/>
									</div>
									<p class="name">Google Play</p>
								</router-link>
							</li>
							<li>
								<router-link to="#" class="link-over">
									<div class="img">
										<img
											src="../assets/img/google-img3.svg"
											alt="Android"
										/>
									</div>
									<p class="name">Android</p>
								</router-link>
							</li>
						</ul>
						<h3>{{ $t("Add and Backup Auth Key") }}</h3>
						<p class="txt">
							{{
								$t(
									"Open the Google Authenticator APP, scan the QR code below, or enter the key manually."
								)
							}}
							{{ $t("Please save and backup this key.") }}
							{{
								$t(
									"It is required for setup in google authenticator when you lost or replaced your smartphone."
								)
							}}
						</p>
						<div class="box">
							<div class="tab-content">
								<div class="content">
									<div class="img">
										<img
											src="../assets/img/qr-img.png"
											alt=""
										/>
									</div>
									<div class="input-area">
										<input
											type="text"
											name=""
											v-model="code"
											readonly
										/>
										<span
											v-clipboard:copy="code"
											v-clipboard:success="codeCopy"
											v-clipboard:error="codeError"
											>COPY</span
										>
									</div>
								</div>
							</div>
						</div>
						<h3>{{ $t("Complete Binding") }}</h3>
						<p class="txt">
							{{
								$t(
									"Please ensure you save and backup the above key before entering the 6-Digit Verification Code below."
								)
							}}
						</p>
						<form>
							<div class="input-area">
								<input
									type="text"
									name=""
									:placeholder="
										$t('Google authentication code')
									"
								/>
							</div>
							<div class="btn">
								<button type="button" class="link-over">
									{{ $t("Bind") }}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<!-- /.contents -->

		<Footer title="Authentication" />
	</div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
	name: "Authentication",
	components: {
		Header,
		HeaderMenu,
		Sidebar,
		Footer,
	},
	data: () => {
		return {
			title: "Authentication",
			isActive: "1",
			code: "*******",
		};
	},
	methods: {
		codeCopy: function (e) {
			alert("You just copied: " + e.text);
		},
		codeError: function () {
			alert("Failed to copy texts");
		},
	},
	computed: {},
	mounted: function () {},
};
</script>
